// extracted by mini-css-extract-plugin
export var conversationListItem = "_wn-2";
export var fullBleedList = "_wn-3";
export var messageText = "_wn-1";
export var previewText = "_wn-0";